const _socks = {
	'aerobics-leggings': {
		name: 'aerobics leggings',
		variations: {
			'red-and-pink': 'Red & pink',
			'emerald-and-lime': 'Emerald & lime',
			'purple-and-orange': 'Purple & orange',
			'light-blue-and-salmon-pink': 'Light blue & salmon pink',
			'yellow-and-blue': 'Yellow & blue',
		},
	},
	'aran-knit-socks': {
		name: 'Aran-knit socks',
		variations: {
			beige: 'Beige',
			white: 'White',
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			black: 'Black',
		},
	},
	'argyle-crew-socks': {
		name: 'argyle crew socks',
		variations: {
			blue: 'Blue',
			red: 'Red',
			green: 'Green',
			beige: 'Beige',
			gray: 'Gray',
			white: 'White',
			orange: 'Orange',
			pink: 'Pink',
		},
	},
	'back-bow-socks': {
		name: 'back-bow socks',
		variations: {
			pink: 'Pink',
			yellow: 'Yellow',
			black: 'Black',
			white: 'White',
			blue: 'Blue',
			'peacock-blue': 'Peacock blue',
		},
	},
	'bobby-socks': {
		name: 'bobby socks',
		variations: {
			white: 'White',
			gray: 'Gray',
			black: 'Black',
			brown: 'Brown',
		},
	},
	'color-blocked-socks': {
		name: 'color-blocked socks',
		variations: {
			purple: 'Purple',
			green: 'Green',
			brown: 'Brown',
			blue: 'Blue',
			beige: 'Beige',
			white: 'White',
			lime: 'Lime',
			pink: 'Pink',
		},
	},
	'compression-tights': {
		name: 'compression tights',
		variations: {
			blue: 'Blue',
			yellow: 'Yellow',
			pink: 'Pink',
			mint: 'Mint',
			red: 'Red',
		},
	},
	'country-socks': {
		name: 'country socks',
		variations: {
			'red-ribbons': 'Red ribbons',
			'green-ribbons': 'Green ribbons',
			'blue-ribbons': 'Blue ribbons',
			'black-ribbons': 'Black ribbons',
		},
	},
	'crocheted-socks': {
		name: 'crocheted socks',
		variations: {
			beige: 'Beige',
			gray: 'Gray',
			purple: 'Purple',
			blue: 'Blue',
		},
	},
	'denim-leggings': {
		name: 'denim leggings',
		variations: {
			blue: 'Blue',
			'indigo-blue': 'Indigo blue',
			'saxon-blue': 'Saxon blue',
			'light-blue': 'Light blue',
		},
	},
	'dotted-knee-high-socks': {
		name: 'dotted knee-high socks',
		variations: {
			black: 'Black',
			yellow: 'Yellow',
			cyan: 'Cyan',
			gray: 'Gray',
		},
	},
	'embroidered-flower-tights': {
		name: 'embroidered-flower tights',
		variations: {
			brown: 'Brown',
			black: 'Black',
			green: 'Green',
			beige: 'Beige',
			blue: 'Blue',
			purple: 'Purple',
		},
	},
	'everyday-socks': {
		name: 'everyday socks',
		variations: {
			brown: 'Brown',
			black: 'Black',
			'navy-blue': 'Navy blue',
			gray: 'Gray',
			beige: 'Beige',
			white: 'White',
		},
	},
	'everyday-tights': {
		name: 'everyday tights',
		variations: {
			black: 'Black',
			'light-gray': 'Light gray',
			gray: 'Gray',
			white: 'White',
			'navy-blue': 'Navy blue',
			beige: 'Beige',
		},
	},
	'fishnet-tights': {
		name: 'fishnet tights',
		variations: {
			black: 'Black',
			white: 'White',
			red: 'Red',
		},
	},
	'flowery-dot-tights': {
		name: 'flowery-dot tights',
		variations: {
			white: 'White',
			pink: 'Pink',
			blue: 'Blue',
			yellow: 'Yellow',
			black: 'Black',
		},
	},
	'frilly-knee-high-socks': {
		name: 'frilly knee-high socks',
		variations: {
			black: 'Black',
			green: 'Green',
			red: 'Red',
			brown: 'Brown',
			mint: 'Mint',
			pink: 'Pink',
			purple: 'Purple',
			yellow: 'Yellow',
		},
	},
	'frilly-socks': {
		name: 'frilly socks',
		variations: {
			white: 'White',
			yellow: 'Yellow',
			pink: 'Pink',
			green: 'Green',
			purple: 'Purple',
			blue: 'Blue',
		},
	},
	'funny-face-socks': {
		name: 'funny-face socks',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			red: 'Red',
			green: 'Green',
			black: 'Black',
		},
	},
	'garter-socks': {
		name: 'garter socks',
		variations: {
			black: 'Black',
			white: 'White',
			purple: 'Purple',
			red: 'Red',
		},
	},
	'geometric-print-socks': {
		name: 'geometric-print socks',
		variations: {
			yellow: 'Yellow',
			'peacock-blue': 'Peacock blue',
			purple: 'Purple',
			beige: 'Beige',
			pink: 'Pink',
			green: 'Green',
		},
	},
	'hand-knit-socks': {
		name: 'hand-knit socks',
		variations: {
			green: 'Green',
			purple: 'Purple',
			orange: 'Orange',
		},
	},
	'holey-socks': {
		name: 'holey socks',
		variations: {
			blue: 'Blue',
			'navy-blue': 'Navy blue',
			white: 'White',
		},
	},
	'holey-tights': {
		name: 'holey tights',
		variations: {
			black: 'Black',
			pink: 'Pink',
			'light-blue': 'Light blue',
			red: 'Red',
			purple: 'Purple',
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
		},
	},
	'kiddie-socks': {
		name: 'kiddie socks',
		variations: {
			'red-and-light-blue': 'Red & light blue',
			'blue-and-orange': 'Blue & orange',
			'lime-and-pink': 'Lime & pink',
			'yellow-and-purple': 'Yellow & purple',
			'light-blue-and-red': 'Light blue & red',
			'purple-and-green': 'Purple & green',
			'pink-and-yellow': 'Pink & yellow',
			'black-and-gray': 'Black & gray',
		},
	},
	'labelle-socks': {
		name: 'Labelle socks',
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'labelle-tights': {
		name: 'Labelle tights',
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'lace-socks': {
		name: 'lace socks',
		variations: {
			white: 'White',
			pink: 'Pink',
			green: 'Green',
			black: 'Black',
			beige: 'Beige',
		},
	},
	'layered-socks': {
		name: 'layered socks',
		variations: {
			purple: 'Purple',
			blue: 'Blue',
			yellow: 'Yellow',
			green: 'Green',
			red: 'Red',
			orange: 'Orange',
		},
	},
	'leg-warmers': {
		name: 'leg warmers',
		variations: {
			purple: 'Purple',
			black: 'Black',
			gray: 'Gray',
			pink: 'Pink',
			'light-purple': 'Light purple',
			blue: 'Blue',
		},
	},
	'mixed-tweed-socks': {
		name: 'mixed-tweed socks',
		variations: {
			red: 'Red',
			avocado: 'Avocado',
			'light-blue': 'Light blue',
			purple: 'Purple',
			blue: 'Blue',
			orange: 'Orange',
			lime: 'Lime',
			pink: 'Pink',
		},
	},
	'neon-leggings': {
		name: 'neon leggings',
		variations: {
			yellow: 'Yellow',
			pink: 'Pink',
			orange: 'Orange',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'neon-tights': {
		name: 'neon tights',
		variations: {
			yellow: 'Yellow',
			pink: 'Pink',
			orange: 'Orange',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'no-show-socks': {
		name: 'no-show socks',
		variations: {
			gray: 'Gray',
			white: 'White',
			'berry-red': 'Berry red',
			'light-blue': 'Light blue',
			orange: 'Orange',
			green: 'Green',
			'navy-blue': 'Navy blue',
			yellow: 'Yellow',
		},
	},
	'nook-inc-socks': {
		name: 'Nook Inc. socks',
		variations: {
			yellow: 'Yellow',
		},
	},
	'nordic-socks': {
		name: 'nordic socks',
		variations: {
			'navy-blue': 'Navy blue',
			ivory: 'Ivory',
			red: 'Red',
			blue: 'Blue',
			gray: 'Gray',
			green: 'Green',
			'light-blue': 'Light blue',
		},
	},
	'patterned-stockings': {
		name: 'patterned stockings',
		variations: {
			black: 'Black',
			white: 'White',
		},
	},
	'pom-pom-socks': {
		name: 'pom-pom socks',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			green: 'Green',
			orange: 'Orange',
			purple: 'Purple',
		},
	},
	'puckered-socks': {
		name: 'puckered socks',
		variations: {
			mustard: 'Mustard',
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'running-tights': {
		name: 'running tights',
		variations: {
			pink: 'Pink',
			yellow: 'Yellow',
			blue: 'Blue',
			green: 'Green',
		},
	},
	'semi-opaque-socks': {
		name: 'semi-opaque socks',
		variations: {
			green: 'Green',
			red: 'Red',
			blue: 'Blue',
			'navy-blue': 'Navy blue',
			purple: 'Purple',
			camel: 'Camel',
			avocado: 'Avocado',
			brown: 'Brown',
		},
	},
	'semi-opaque-tights': {
		name: 'semi-opaque tights',
		variations: {
			brown: 'Brown',
			yellow: 'Yellow',
			green: 'Green',
			purple: 'Purple',
			blue: 'Blue',
			pink: 'Pink',
			red: 'Red',
			'yellow-green': 'Yellow-green',
		},
	},
	'sequin-leggings': {
		name: 'sequin leggings',
		variations: {
			pink: 'Pink',
			red: 'Red',
			black: 'Black',
			yellow: 'Yellow',
			white: 'White',
			blue: 'Blue',
			purple: 'Purple',
			green: 'Green',
		},
	},
	'sheer-socks': {
		name: 'sheer socks',
		variations: {
			blue: 'Blue',
			'berry-red': 'Berry red',
			brown: 'Brown',
			green: 'Green',
			olive: 'Olive',
			gray: 'Gray',
		},
	},
	'simple-knee-high-socks': {
		name: 'simple knee-high socks',
		variations: {
			pink: 'Pink',
			white: 'White',
			red: 'Red',
			blue: 'Blue',
		},
	},
	'simple-accent-socks': {
		name: 'simple-accent socks',
		variations: {
			'navy-blue': 'Navy blue',
			black: 'Black',
			white: 'White',
			gray: 'Gray',
			blue: 'Blue',
			orange: 'Orange',
			red: 'Red',
			pink: 'Pink',
		},
	},
	'soccer-socks': {
		name: 'soccer socks',
		variations: {
			blue: 'Blue',
			red: 'Red',
			green: 'Green',
			'light-blue': 'Light blue',
			black: 'Black',
			orange: 'Orange',
			white: 'White',
		},
	},
	'spider-web-tights': {
		name: 'spider-web tights',
		variations: {
			black: 'Black',
			white: 'White',
			orange: 'Orange',
			purple: 'Purple',
		},
	},
	stockings: {
		name: 'stockings',
		variations: {
			black: 'Black',
			gray: 'Gray',
			white: 'White',
			brown: 'Brown',
			beige: 'Beige',
		},
	},
	'stretch-leggings': {
		name: 'stretch leggings',
		variations: {
			'navy-blue': 'Navy blue',
			gray: 'Gray',
			'dark-gray': 'Dark gray',
			white: 'White',
			black: 'Black',
			brown: 'Brown',
			green: 'Green',
		},
	},
	'striped-socks': {
		name: 'striped socks',
		variations: {
			monotone: 'Monotone',
			'light-blue': 'Light blue',
			green: 'Green',
			yellow: 'Yellow',
			orange: 'Orange',
			red: 'Red',
			purple: 'Purple',
			blue: 'Blue',
		},
	},
	'striped-tights': {
		name: 'striped tights',
		variations: {
			red: 'Red',
			gray: 'Gray',
			pink: 'Pink',
			'light-blue': 'Light blue',
			yellow: 'Yellow',
			purple: 'Purple',
			green: 'Green',
			orange: 'Orange',
		},
	},
	tabi: {
		name: 'tabi',
		variations: {
			white: 'White',
			black: 'Black',
			'navy-blue': 'Navy blue',
		},
	},
	'terry-cloth-socks': {
		name: 'terry-cloth socks',
		variations: {
			pink: 'Pink',
			purple: 'Purple',
			blue: 'Blue',
			green: 'Green',
			beige: 'Beige',
			red: 'Red',
			gray: 'Gray',
		},
	},
	'tube-socks': {
		name: 'tube socks',
		variations: {
			blue: 'Blue',
			orange: 'Orange',
			green: 'Green',
			red: 'Red',
			'navy-blue': 'Navy blue',
			'berry-red': 'Berry red',
			'dark-green': 'Dark green',
			purple: 'Purple',
		},
	},
	'ultra-no-show-socks': {
		name: 'ultra no-show socks',
		variations: {
			blue: 'Blue',
			pink: 'Pink',
			brown: 'Brown',
			olive: 'Olive',
			green: 'Green',
			purple: 'Purple',
			black: 'Black',
			white: 'White',
		},
	},
	'vivid-leggings': {
		name: 'vivid leggings',
		variations: {
			'light-blue': 'Light blue',
			purple: 'Purple',
			red: 'Red',
			pink: 'Pink',
			blue: 'Blue',
			yellow: 'Yellow',
			green: 'Green',
			orange: 'Orange',
		},
	},
	'vivid-socks': {
		name: 'vivid socks',
		variations: {
			green: 'Green',
			red: 'Red',
			'light-blue': 'Light blue',
			blue: 'Blue',
			purple: 'Purple',
			pink: 'Pink',
			orange: 'Orange',
			yellow: 'Yellow',
		},
	},
	'vivid-tights': {
		name: 'vivid tights',
		variations: {
			'light-blue': 'Light blue',
			purple: 'Purple',
			red: 'Red',
			pink: 'Pink',
			blue: 'Blue',
			yellow: 'Yellow',
			green: 'Green',
			orange: 'Orange',
		},
	},
	'wave-print-socks': {
		name: 'wave-print socks',
		variations: {
			blue: 'Blue',
			brown: 'Brown',
			purple: 'Purple',
			green: 'Green',
			gray: 'Gray',
		},
	},
};

export { _socks };
